import dayjs, { Dayjs } from 'dayjs';
import { PlannerMenu } from 'pages/oldPlanner/PlannerMenu';
import React, { useState } from 'react';
import { BundleStatus } from 'types/bundleTypes';
import { OrderFilterOptionsType } from 'types/OrderFilterOptionsType';
import { ProductType, Region } from 'types/orderTypes';
import './PlannerContainer.scss';
import { PlannerWrapper } from './PlannerWrapper';

interface PlannerProps {
  region: Region;
  limitedAccess?: boolean;
}

export const Planner = ({ region, limitedAccess, ...props }: PlannerProps) => {
  const [date, setDate] = useState<Dayjs>(dayjs());

  const onDateChange = (newDate: string) => {
    setDate(dayjs(newDate));
  };

  return (
    <>
      <PlannerMenu limitedAccess={limitedAccess} />

      <PlannerWrapper
        activeDate={date}
        region={region}
        onDateChange={onDateChange}
      />
    </>
  );
};

export interface FilterType extends OrderFilterOptionsType {
  windows: string[];
  stores: string[];
  bundleStatus: BundleStatus[];
  productType: ProductType;
}
